import React, { Component } from "react";
import Footer from "../exercise/Footer";
import GridesView from "./gridesView";
const $ = require("$");

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({ visible: val });
    };
    componentDidMount() {
        if (this.props.data.subject === "0") {
            this.setState({ visible: true }); //数学题默认答案显示
        }
    }

    componentDidUpdate() {}

    createHtml = str => ({ __html: str ? str : `&nbsp;` });

    render() {
        const { visible } = this.state;
        let originData = this.props.data;
        // if (this.props.errorAnswer) {
        //     originData.answer = this.props.errorAnswer;
        // } //题目检错页显示的是错的的答题答案

        const { num, children } = this.props;
        let stem = originData.stem;
        stem = JSON.parse(stem);
        let answer = JSON.parse(originData.answer);
        return (
            <div className="box-exercise" ref={"viewer"}>
                <div className="exercise-content">
                    {num !== "undefined" && (
                        <div className="exercise-num">
                            <p className="math_text">{`${num + 1}、`}</p>
                        </div>
                    )}
                    <div className="exercise-con">
                        <GridesView values={stem.values} />
                        <div style={{ marginTop: 15 }}>
                            <span style={{ marginRight: 20 }}>
                                <span htmlFor="">救生艇数量：</span>
                                <span>{stem.limit.count_1==-1?'不限制':stem.limit.count_1}</span>
                            </span>

                            <span style={{ marginRight: 20 }}>
                                <span htmlFor="">帆船数量：</span>
                                <span>{stem.limit.count_2==-1?'不限制':stem.limit.count_2}</span>
                            </span>

                            <span style={{ marginRight: 20 }}>
                                <span htmlFor="">战舰数量：</span>
                                <span>{stem.limit.count_3==-1?'不限制':stem.limit.count_3}</span>
                            </span>
                            <span style={{ marginRight: 20 }}>
                                <span htmlFor="">灯泡数量：</span>
                                <span>{stem.tips}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="exercise-footer">
                    {visible && (
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block">
                                    <span style={{ fontSize: 14 }}>
                                        {"正确答案："}
                                    </span>
                                </div>
                                <div
                                    className="inline-block"
                                    style={{ width: "80%" }}
                                >
                                    {!this.props.isSub ? (
                                        <GridesView
                                            values={answer}
                                        />
                                    ) : (
                                        <span
                                            style={{
                                                color: "blue",
                                                fontSize: 14
                                            }}
                                        >
                                            见母题
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="footer-show relative">
                        <Footer
                            {...this.props}
                            obj={originData}
                            subject={this.props.data.subject}
                        >
                            {this.props.canShowAnswer ? (
                                <button
                                    className="question-btn"
                                    onClick={e =>
                                        this.toggleAnswer(!visible, e)
                                    }
                                >
                                    {!visible ? "显示答案" : "隐藏答案"}
                                </button>
                            ) : null}
                        </Footer>
                    </div>
                </div>
            </div>
        );
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ai_sudoku_ship/viewForView.js